import { createTheme, responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  // 1. Define Breakpoints for better control
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: { main: '#2F727C', dark: '#1e4b52', contrastText: '#fff' },
    secondary: { main: '#2FC0CC' },
    accent: { main: '#BFE384' },
    error: { main: '#fc5c65' },
    chip: { main: '#F6B93B' },
    background: { default: '#f0f4f5', paper: '#ffffff' },
    text: { primary: '#1A3A3F', secondary: '#5d7e83' },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    // Make headers scale with screen size
    h4: { 
      fontWeight: 900, 
      //fontFamily: 'Raleway', 
      letterSpacing: '-0.5px',
      '@media (max-width:600px)': { fontSize: '1.75rem' } 
    },
    h6: { 
      fontWeight: 800, 
      //fontFamily: 'Raleway',
      '@media (max-width:600px)': { fontSize: '1.1rem' }
    },
    subtitle2: { 
      fontWeight: 700, 
      textTransform: 'uppercase', 
      fontSize: '0.75rem', 
      letterSpacing: '1px' 
    },
    body2: {
      fontSize: '0.875rem',
      '@media (max-width:600px)': { fontSize: '0.8rem' }
    }
  },
  shape: { borderRadius: 8 }, // Increased slightly for a modern touch feel
  components: {
 MuiButton: {
    styleOverrides: {
      root: {
        // Base dimensions from your CSS
        borderRadius: '6px',
        minWidth: '100px',
        minHeight: '34px',
        textTransform: 'none',
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: 1.5, // 18px/12px unitless
        padding: '8px 12px',

        // Responsive overrides
        '@media (max-width: 500px)': {
          minWidth: '150px',
          minHeight: '40px',
          padding: '10px 20px',
          fontSize: '14px',
          lineHeight: 1.42, // 20px/14px
        },
      },
      // ─── DESTRUCTIVE TERTIARY STYLE ───
      // We map this to <Button variant="text" color="error">
      textError: {
        backgroundColor: 'transparent',
        color: '#fc5c65', // var(--fg-btn-destructive-tertiary-text-color-default-dark)
        border: '1px solid transparent',

        '&:hover': {
          backgroundColor: 'rgba(235, 59, 90, 0.15)', // var(--fg-btn-destructive-tertiary-bg-color-hov-dark)
          color: '#fc5c65',
        },

        '&:active': {
          backgroundColor: 'rgba(192, 12, 44, 0.4)', // var(--fg-btn-destructive-tertiary-bg-color-pressed-dark)
          color: '#ffffff',
        },

        '&.Mui-disabled': {
          backgroundColor: 'transparent',
          color: '#536465', // var(--fg-btn-destructive-tertiary-text-color-disabled-dark)
        },

        '&.Mui-focusVisible': {
          outline: '2px solid #45aaf2', // var(--fg-state-focus-color-border-dark)
          outlineOffset: '2px',
        },
      },
    },
  },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4, // More mobile-friendly rounded corners
          border: '1px solid rgba(47, 114, 124, 0.15)',
          background: 'rgba(255, 255, 255, 1)',
          boxShadow: '0 2px 8px 0 rgba(31, 38, 135, 0.05)',
          // Remove padding on small screens to save space
          '& .MuiCardContent-root': {
            padding: '24px',
            '@media (max-width:600px)': {
              padding: '16px',
            }
          }
        },
      },
    },
    // ─── TECHNICAL TABLE OVERRIDES (Mobile Optimized) ───
    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          border: '1px solid rgba(47, 114, 124, 0.12)',
          overflowX: 'auto', // Ensures horizontal scroll on mobile
          WebkitOverflowScrolling: 'touch', // Smooth scroll for iOS
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '16px',
          borderColor: 'rgba(47, 114, 124, 0.08)',
          // Reduce padding on mobile to show more data
          '@media (max-width:600px)': {
            padding: '10px 8px',
          },
        },
        head: {
          fontSize: '0.7rem',
          fontWeight: 800,
          textTransform: 'uppercase',
          letterSpacing: '0.05rem',
          color: '#5d7e83',
          whiteSpace: 'nowrap', // Prevents headers from wrapping awkwardly
        },
      },
    },
      MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: '12px',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        fontSize: '12px',
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: '12px',
      },
    },
  },
  },
});

// Automatically generate fluid typography for all tags (h1, h2, p, etc)
theme = responsiveFontSizes(theme);

export { theme };